import createPendingData from '../createPendingData';
import destroyPendingData from '../destroyPendingData';
import updatePendingData from '../updatePendingData';

/**
 * Creator function for all pending actions
 * @return {Object} The set of all actions
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * const pendingActions = makePendingActions();
 * dispatch(pendingActions.destroyPendingData({ id: `foobar` }));
 */
const makePendingActions = () => ({
  createPendingData,
  destroyPendingData,
  updatePendingData,
});

/** @component */
export default makePendingActions;
